import { Alert } from "interfaces/alert";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";

/**
 * @property {boolean} loading Whether the alert is currently being fetched
 * @property {boolean} error Whether an error occurred during the fetching of the alert
 * @property {Alert | undefined} alert The alert object, undefined while loading or if an error occurred
 */
export interface AlertResponse {
  loading: boolean;
  error: boolean;
  alert: Alert | undefined;
}

/**
 * Fetches an alert by the given id
 * @param alertId the id of the alert to fetch
 * @returns a response object containing: loading, error and the alert object
 */
export const useGetAlert = (
  alertId: string | number | undefined
): AlertResponse => {
  const { loading, error, response } = useFetchGetV2(
    `alerts/${alertId}`,
    alertId === undefined
  );

  return {
    loading,
    error,
    alert: response as Alert | undefined
  };
};
